// Small bootstrap for bp modules
import { initEvents } from './events.js';

export function init() {
    // initialize event handlers and any public bootstrapping
    if (typeof initEvents === 'function') initEvents();
}

export default { init };
